import { TabConfig, NavigationItem, NavigationGroupConfig } from '@/app/navigation/types'
import { PipelineTab } from '../tabs/pipeline'
import { TasksTab } from '../tabs/mes-taches'
import { UserManagementTab } from '../tabs/user-management'
import { SearchTab } from '../tabs/search'
import { PaymentTab } from '../tabs/payment'
import { ExpertTab } from '../tabs/expert'
import { AutomatisationTab } from '../tabs/automatisation'
import { IATab } from '../tabs/ia'
import { TrackerTab } from '../tabs/tracker'
import { EmailsTab } from '../tabs/emails'
import { MonEspaceTab } from '../tabs/mon-espace/MonEspaceTab'
import { TicketTab } from '../tabs/ticket'
import { WhatsNewTab } from '../tabs/whats-new'
import { EquipeTab } from '../tabs/equipe'
import { MondayMeetingTab } from '../tabs/monday-meeting'
import { BureauActivityTab } from '../tabs/bureau-activity'
import { FacturationTab } from '../tabs/facturation'
import { BoardsTab } from '../tabs/boards'
import { SMSTab } from '../tabs/sms'
import { AgentLeaTab } from '../tabs/agent-lea'
import { LeaV3Tab } from '../tabs/lea-v3'
import { VoipTab } from '../tabs/voip'
import { AppelsTab } from '../tabs/appels'

// Flat tabs array for routing (used by AdminLayout Routes)
export const adminTabs: TabConfig[] = [
  {
    id: 'whats-new',
    label: 'Nouveautés',
    icon: 'SparklesIcon',
    component: WhatsNewTab,
    path: '/admin/whats-new',
    position: 0,
    permissions: ['view_dashboard'],
    hidden: true
  },
  {
    id: 'search',
    label: 'Recherche',
    icon: 'DocumentIcon',
    component: SearchTab,
    path: '/admin/search',
    position: 1,
    permissions: ['view_all_customers', 'view_all_expertises']
  },
  {
    id: 'pipeline',
    label: 'Pipeline',
    icon: 'PipelineIcon',
    component: PipelineTab,
    path: '/admin/pipeline',
    position: 2,
    permissions: ['view_pipeline', 'admin_pipeline']
  },
  {
    id: 'agent-lea',
    label: 'Agent Léa',
    icon: 'SparklesIcon',
    component: AgentLeaTab,
    path: '/admin/agent-lea',
    position: 3,
    permissions: ['view_dashboard']
  },
  {
    id: 'lea-v3',
    label: 'Léa V3',
    icon: 'SparklesIcon',
    component: LeaV3Tab,
    path: '/admin/lea-v3',
    position: 3.5,
    permissions: ['admin_only']
  },
  {
    id: 'tasks',
    label: 'Mes Tâches',
    icon: 'TaskIcon',
    component: TasksTab,
    path: '/admin/tasks',
    position: 4,
    permissions: ['view_tasks']
  },
  {
    id: 'automatisation',
    label: 'Automatisations',
    icon: 'ClockIcon',
    component: AutomatisationTab,
    path: '/admin/automatisation',
    position: 5,
    permissions: ['view_tasks', 'manage_automations']
  },
  {
    id: 'payment',
    label: 'Paiements',
    icon: 'DocumentIcon',
    component: PaymentTab,
    path: '/admin/payment',
    position: 6,
    permissions: ['view_all_customers']
  },
  {
    id: 'expert',
    label: 'Experts',
    icon: 'UserGroupIcon',
    component: ExpertTab,
    path: '/admin/expert',
    position: 7,
    permissions: ['view_all_customers', 'manage_experts']
  },
  {
    id: 'ia',
    label: 'IA',
    icon: 'SparklesIcon',
    component: IATab,
    path: '/admin/ia',
    position: 8,
    permissions: ['view_dashboard']
  },
  {
    id: 'tracker',
    label: 'Tracker',
    icon: 'ClipboardDocumentCheckIcon',
    component: TrackerTab,
    path: '/admin/tracker',
    position: 9,
    permissions: ['view_dashboard']
  },
  {
    id: 'emails',
    label: 'Emails',
    icon: 'EnvelopeIcon',
    component: EmailsTab,
    path: '/admin/emails',
    position: 10,
    permissions: ['view_dashboard'] // Admin and bureau roles
  },
  {
    id: 'sms',
    label: 'SMS',
    icon: 'ChatBubbleLeftRightIcon',
    component: SMSTab,
    path: '/admin/sms',
    position: 11,
    permissions: ['view_dashboard'] // Admin and bureau roles
  },
  {
    id: 'ticket',
    label: 'Ticket',
    icon: 'BuildingOfficeIcon',
    component: TicketTab,
    path: '/admin/ticket',
    position: 11,
    permissions: ['view_dashboard'] // Admin and bureau roles
  },
  {
    id: 'monday-meeting',
    label: 'Réunion du lundi',
    icon: 'CalendarDaysIcon',
    component: MondayMeetingTab,
    path: '/admin/monday-meeting',
    position: 12,
    permissions: ['view_dashboard'] // Admin and bureau roles
  },
  {
    id: 'user-management',
    label: 'Gestion utilisateurs',
    icon: 'UserGroupIcon',
    component: UserManagementTab,
    path: '/admin/user-management',
    position: 12,
    permissions: ['manage_users']
  },
  {
    id: 'mon-espace',
    label: 'Mon Espace',
    icon: 'CalendarIcon',
    component: MonEspaceTab,
    path: '/admin/mon-espace',
    position: 13,
    permissions: ['view_dashboard']
  },
  {
    id: 'equipe',
    label: 'Équipe',
    icon: 'UserGroupIcon',
    component: EquipeTab,
    path: '/admin/equipe',
    position: 14,
    permissions: ['view_dashboard']
  },
  {
    id: 'bureau-activity',
    label: 'Activité Bureau',
    icon: 'ChartBarIcon',
    component: BureauActivityTab,
    path: '/admin/bureau-activity',
    position: 15,
    permissions: ['admin_only']
  },
  {
    id: 'facturation',
    label: 'Facturation',
    icon: 'DocumentCurrencyEuroIcon',
    component: FacturationTab,
    path: '/admin/facturation',
    position: 16,
    permissions: ['view_all_customers']
  },
  {
    id: 'voip',
    label: 'VoIP',
    icon: 'PhoneIcon',
    component: VoipTab,
    path: '/admin/voip',
    position: 17,
    permissions: ['admin_only']
  },
  {
    id: 'appels',
    label: 'Appels',
    icon: 'PhoneIcon',
    component: AppelsTab,
    path: '/admin/appels',
    position: 17.5,
    permissions: ['view_dashboard'] // Admin and bureau roles
  },
  {
    id: 'boards',
    label: 'Boards',
    icon: 'Squares2X2Icon',
    component: BoardsTab,
    path: '/admin/boards',
    position: 18,
    permissions: ['view_dashboard']
  }
]

// Grouped navigation structure for NavigationRail
export const adminNavigation: NavigationItem[] = [
  // Hidden: Whats New (accessed via logo click)
  {
    id: 'whats-new',
    label: 'Nouveautés',
    icon: 'SparklesIcon',
    component: WhatsNewTab,
    path: '/admin/whats-new',
    position: 0,
    permissions: ['view_dashboard'],
    hidden: true
  } as TabConfig,

  // Group: Dossiers
  {
    id: 'group-dossiers',
    label: 'Dossiers',
    icon: 'FolderIcon',
    position: 1,
    defaultOpen: true,
    children: [
      {
        id: 'nouveau-dossier',
        label: 'Nouveau dossier',
        icon: 'PlusCircleIcon',
        path: '/admin/nouveau-dossier',
        position: 0,
        permissions: ['admin_pipeline']
      },
      {
        id: 'mes-dossiers',
        label: 'Mes dossiers',
        icon: 'FolderIcon',
        path: '/admin/mes-dossiers',
        position: 0.5,
        permissions: ['admin_pipeline']
      },
      {
        id: 'search',
        label: 'Recherche',
        icon: 'DocumentIcon',
        component: SearchTab,
        path: '/admin/search',
        position: 1,
        permissions: ['view_all_customers', 'view_all_expertises']
      },
      {
        id: 'pipeline',
        label: 'Pipeline',
        icon: 'PipelineIcon',
        component: PipelineTab,
        path: '/admin/pipeline',
        position: 2,
        permissions: ['view_pipeline', 'admin_pipeline']
      },
      {
        id: 'tracker',
        label: 'Tracker',
        icon: 'ClipboardDocumentCheckIcon',
        component: TrackerTab,
        path: '/admin/tracker',
        position: 3,
        permissions: ['view_dashboard']
      },
      {
        id: 'agent-lea',
        label: 'Agent Léa',
        icon: 'SparklesIcon',
        component: AgentLeaTab,
        path: '/admin/agent-lea',
        position: 4,
        permissions: ['view_dashboard']
      },
      {
        id: 'lea-v3',
        label: 'Léa V3',
        icon: 'SparklesIcon',
        component: LeaV3Tab,
        path: '/admin/lea-v3',
        position: 5,
        permissions: ['admin_only']
      }
    ]
  } as NavigationGroupConfig,

  // Group: Travail
  {
    id: 'group-travail',
    label: 'Travail',
    icon: 'ClipboardDocumentCheckIcon',
    position: 2,
    defaultOpen: true,
    children: [
      {
        id: 'tasks',
        label: 'Mes Tâches',
        icon: 'TaskIcon',
        component: TasksTab,
        path: '/admin/tasks',
        position: 1,
        permissions: ['view_tasks']
      },
      {
        id: 'emails',
        label: 'Emails',
        icon: 'EnvelopeIcon',
        component: EmailsTab,
        path: '/admin/emails',
        position: 2,
        permissions: ['view_dashboard']
      },
      {
        id: 'sms',
        label: 'SMS',
        icon: 'ChatBubbleLeftRightIcon',
        component: SMSTab,
        path: '/admin/sms',
        position: 3,
        permissions: ['view_dashboard']
      },
      {
        id: 'appels',
        label: 'Appels',
        icon: 'PhoneIcon',
        component: AppelsTab,
        path: '/admin/appels',
        position: 4,
        permissions: ['view_dashboard']
      }
    ]
  } as NavigationGroupConfig,

  // Group: Outils
  {
    id: 'group-outils',
    label: 'Outils',
    icon: 'WrenchScrewdriverIcon',
    position: 3,
    defaultOpen: false,
    children: [
      {
        id: 'payment',
        label: 'Paiements',
        icon: 'BanknotesIcon',
        component: PaymentTab,
        path: '/admin/payment',
        position: 1,
        permissions: ['view_all_customers']
      },
      {
        id: 'facturation',
        label: 'Facturation',
        icon: 'DocumentCurrencyEuroIcon',
        component: FacturationTab,
        path: '/admin/facturation',
        position: 2,
        permissions: ['view_all_customers']
      },
      {
        id: 'monday-meeting',
        label: 'Réunion du lundi',
        icon: 'CalendarDaysIcon',
        component: MondayMeetingTab,
        path: '/admin/monday-meeting',
        position: 3,
        permissions: ['view_dashboard']
      },
      {
        id: 'ticket',
        label: 'Ticket',
        icon: 'BuildingOfficeIcon',
        component: TicketTab,
        path: '/admin/ticket',
        position: 4,
        permissions: ['view_dashboard']
      },
      {
        id: 'automatisation',
        label: 'Automatisations',
        icon: 'ClockIcon',
        component: AutomatisationTab,
        path: '/admin/automatisation',
        position: 5,
        permissions: ['view_tasks', 'manage_automations']
      },
      {
        id: 'ia',
        label: 'IA',
        icon: 'SparklesIcon',
        component: IATab,
        path: '/admin/ia',
        position: 6,
        permissions: ['view_dashboard']
      },
      {
        id: 'boards',
        label: 'Boards',
        icon: 'Squares2X2Icon',
        component: BoardsTab,
        path: '/admin/boards',
        position: 7,
        permissions: ['view_dashboard']
      }
    ]
  } as NavigationGroupConfig,

  // Group: Administration
  {
    id: 'group-admin',
    label: 'Administration',
    icon: 'Cog6ToothIcon',
    position: 4,
    defaultOpen: false,
    children: [
      {
        id: 'expert',
        label: 'Experts',
        icon: 'UserGroupIcon',
        component: ExpertTab,
        path: '/admin/expert',
        position: 1,
        permissions: ['view_all_customers', 'manage_experts']
      },
      {
        id: 'user-management',
        label: 'Utilisateurs',
        icon: 'UserGroupIcon',
        component: UserManagementTab,
        path: '/admin/user-management',
        position: 2,
        permissions: ['manage_users']
      },
      {
        id: 'equipe',
        label: 'Équipe',
        icon: 'UsersIcon',
        component: EquipeTab,
        path: '/admin/equipe',
        position: 3,
        permissions: ['view_dashboard']
      },
      {
        id: 'mon-espace',
        label: 'Mon Espace',
        icon: 'CalendarIcon',
        component: MonEspaceTab,
        path: '/admin/mon-espace',
        position: 4,
        permissions: ['view_dashboard']
      },
      {
        id: 'bureau-activity',
        label: 'Activité Bureau',
        icon: 'ChartBarIcon',
        component: BureauActivityTab,
        path: '/admin/bureau-activity',
        position: 5,
        permissions: ['admin_only']
      },
      {
        id: 'voip',
        label: 'VoIP',
        icon: 'PhoneIcon',
        component: VoipTab,
        path: '/admin/voip',
        position: 6,
        permissions: ['admin_only']
      }
    ]
  } as NavigationGroupConfig
]